import axios from 'axios'
import React from 'react'

import { AuthAction } from '../context/auth/types.ts'
import {
  handle400Error,
  handle401Error,
  handle403Error,
  handle500Error
} from './utils/errorHandlers.ts'
import {
  ensureFreshToken,
  getAccessToken,
} from './utils/tokens.ts'


export const BASE_URL = import.meta.env.VITE_BASE_URL
export const ACCESS_TOKEN_LIFETIME = parseInt(import.meta.env.VITE_ACCESS_TOKEN_LIFETIME) || 5
export const REFRESH_TOKEN_LIFETIME = parseInt(import.meta.env.VITE_REFRESH_TOKEN_LIFETIME) || 24 * 60 * 60
export const REFRESH_THRESHOLD = parseInt(import.meta.env.VITE_REFRESH_THRESHOLD) || 60
export const setAvailableAuthDispatch = (
  contextDispatch: React.Dispatch<AuthAction>
) => {
  dispatch = contextDispatch
}

const TIMEOUT = 10000
const httpClient = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT,
  headers: {
    'Content-Type': 'application/json'
  }
})

let dispatch: React.Dispatch<AuthAction>

httpClient.interceptors.request.use(async (config) => {
  let accessToken = getAccessToken()
  if (accessToken) {
    try {
      const token = await ensureFreshToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch {
      if (dispatch) {
        dispatch({ type: 'LOGOUT' })
      }
    }
  }

  return config
})

httpClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response === undefined) {
      throw new Error('httpClient interceptors - no response in error object: ' + String(error.message))
    }

    const status = error.response.status

    if (status === 400) {
      handle400Error(error)
    } else if (status === 403) {
      handle403Error(error)
    } else if (status === 500) {
      handle500Error(error)
    } else if (status === 401) {
      return handle401Error(error, dispatch)
    }

    return Promise.reject(error)
  }
)

export default httpClient
